<template>
  <div class="va-iframe-page">
    <div
      class="navbar_style"
      :class="$store.state.user.isNested && 'navbar_style_nested'"
    >
      <Icon class="navbar_icon" name="arrow-left" @click="handleBack" />
      <span>{{ pageTitle }}</span>
      <div class="icon_box"></div>
    </div>
    <div
      class="va-iframe-wrap"
      :class="$store.state.user.isNested && 'va-iframe-wrap_nested'"
    >
      <iframe
        v-if="iframeSrc"
        ref="vaIframe"
        class="va-iframe"
        :src="iframeSrc"
        :allow="iframeAllow"
        frameborder="0"
        scrolling="auto"
        allowfullscreen
        webkitallowfullscreen
        mozallowfullscreen
      />
    </div>
  </div>
</template>

<script>
import { Icon } from "vant";
import { buildVaRedirectUrl, VA_PAY_URL_KEY } from "@/utils";
import l from "@/locales";

// iframe 内嵌 SDK 所需权限（拍照、定位、支付等）
const IFRAME_ALLOW = [
  "accelerometer",
  "autoplay",
  "camera *",
  "encrypted-media",
  "fullscreen *",
  "geolocation *",
  "gyroscope",
  "microphone *",
  "midi",
  "payment *",
  "picture-in-picture",
  "clipboard-read *",
  "clipboard-write *",
  "display-capture *",
  "publickey-credentials-get *",
].join("; ");

export default {
  name: "vaIframe",
  components: { Icon },
  data() {
    return {
      iframeSrc: "",
      iframeAllow: IFRAME_ALLOW,
      l: { ...l.repayMethods, ...l.router },
    };
  },
  computed: {
    pageTitle() {
      const vaType = Number(this.$route.query.vaType);
      if (vaType === 2) return this.l.router_pay_rollover;
      return this.l.bank_pay_immediately;
    },
  },
  created() {
    const cached = sessionStorage.getItem(VA_PAY_URL_KEY);
    if (cached) {
      this.iframeSrc = cached;
      return;
    }
    const va = this.$route.query.va;
    if (va) {
      this.iframeSrc = buildVaRedirectUrl(decodeURIComponent(va));
    }
  },
  methods: {
    handleBack() {
      const busiId = this.$route.query.busiId;
      if (busiId) {
        this.$router.push({ path: "/detail", query: { busiId } });
      } else {
        this.$router.back();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.va-iframe-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background: #f9f9f9;
  box-sizing: border-box;
  overflow: hidden;
}

.va-iframe-wrap {
  flex: 1;
  width: 100%;
  min-height: 0;
  overflow: hidden;
}

.va-iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
  background: #fff;
}
</style>
